import styled from 'styled-components';

export const DirectoryRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing()}px;
  width: 100%;
`;

export const DirectoryTableWrap = styled.div`
  width: 100%;
  max-height: 300px;
  overflow: auto;
`;

export const SecondaryCellText = styled.span`
  color: ${({ theme }) => theme.atlas.semantic.color.type.muted};
`;
